import { render, staticRenderFns } from "./SendDetailRegi.vue?vue&type=template&id=e3791c3a&scoped=true&"
import script from "./SendDetailRegi.vue?vue&type=script&lang=js&"
export * from "./SendDetailRegi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3791c3a",
  null
  
)

export default component.exports